// extracted by mini-css-extract-plugin
module.exports = {"root":"FoodIconsLegend_root__azE0C","item":"FoodIconsLegend_item__1fzvS"};